function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28 13.304v12.622c-3.867 0-7.378 1.561-10 4.074-2.622-2.524-6.133-4.074-10-4.074V13.304c3.867 0 7.378 1.55 10 4.074 2.622-2.525 6.133-4.074 10-4.074zM18 6c1.937 0 3.5 1.631 3.5 3.652s-1.563 3.652-3.5 3.652-3.5-1.631-3.5-3.652C14.5 7.632 16.063 6 18 6z",
  fill: "#98AAB3",
  fillRule: "nonzero"
});

var SvgEducationalInstitutions = function SvgEducationalInstitutions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEducationalInstitutions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/educationalInstitutions.c2a4fb2d.svg";
export { ForwardRef as ReactComponent };